import { connect } from 'react-redux';
import { SurveyTable } from './SurveyTable';
import { cloneSessionAction } from '../../store/redux/actions/sessionActions';

const mapDispatchToProps = dispatch => ({
  cloneSession: sessionId => dispatch(cloneSessionAction.request(sessionId))
});

export default connect(null, mapDispatchToProps)(SurveyTable);
